import { ActionCreator, AnyAction } from 'redux'

import { actionTypes } from 'actions/actionTypes'
import { clickApplePayPay } from 'actions/trackingKeys'

export const trackClickPayWithApplePay: ActionCreator<AnyAction> = () => ({
  type: actionTypes.CLICK_PAY_WITH_APPLE_PAY,
  trackingData: { actionType: clickApplePayPay },
})
